// extracted by mini-css-extract-plugin
export default {"name":"d5Bu3fSNwyDP5taZFz8S"};